import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";
import type { MetricKind, MetricValueResponse } from "./analyticsApi";
import { formatMetric } from "./formatMetric";

/**
 * One metric cell. The single place the tri-state contract renders: a `VALUE` shows the formatted
 * number (a real `0`/`0%` included), `NO_DATA` and `NOT_ENABLED` show a MUTED localized marker — never
 * a `0` — so absence and add-on-off can never be misread as poor performance (edge cases 3/4/6).
 */
export function MetricCell({ kind, value }: { kind: MetricKind; value: MetricValueResponse }) {
  const { t } = useTranslation();
  const formatted = formatMetric(kind, value);

  if (formatted.state === "VALUE") {
    return (
      <span className={css({ fontVariantNumeric: "tabular-nums", fontWeight: "medium" })}>
        {formatted.text}
      </span>
    );
  }
  const label =
    formatted.state === "NOT_ENABLED"
      ? t("analytics.value.notEnabled")
      : t("analytics.value.noData");
  return (
    <span
      className={css({ color: "fg.muted", fontStyle: "italic", fontSize: "sm" })}
      data-state={formatted.state}
    >
      {label}
    </span>
  );
}
